import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import {
  IconTypes,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';

export enum UserSettingsWarningTheme {
  WARNING = 'warning',
}

const THEME_CONFIG: Record<
  UserSettingsWarningTheme,
  {
    backgroundColor: string;
    iconFilter: string;
    iconName: string;
  }
> = {
  [UserSettingsWarningTheme.WARNING]: {
    backgroundColor: '#FEF0C7',
    iconFilter:
      'brightness(0) saturate(100%) invert(28%) sepia(65%) saturate(1483%) hue-rotate(18deg) brightness(96%) contrast(105%)',
    iconName: 'warning_amber_outline',
  },
};

@Component({
  selector: 'app-user-settings-warning',
  standalone: true,
  imports: [CommonModule, PencilIconComponent],
  templateUrl: './user-settings-warning.component.html',
  styleUrls: ['./user-settings-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSettingsWarningComponent implements OnChanges {
  readonly IconTypes = IconTypes;

  @Input() title = '';
  @Input() description = '';
  @Input() theme: UserSettingsWarningTheme = UserSettingsWarningTheme.WARNING;

  readonly backgroundColor$ = new BehaviorSubject<string>(
    THEME_CONFIG[UserSettingsWarningTheme.WARNING].backgroundColor,
  );
  readonly iconFilter$ = new BehaviorSubject<string>(
    THEME_CONFIG[UserSettingsWarningTheme.WARNING].iconFilter,
  );
  readonly iconName$ = new BehaviorSubject<string>(
    THEME_CONFIG[UserSettingsWarningTheme.WARNING].iconName,
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.theme) {
      const themeConfig =
        THEME_CONFIG[this.theme] ?? THEME_CONFIG[UserSettingsWarningTheme.WARNING];

      this.backgroundColor$.next(themeConfig.backgroundColor);
      this.iconFilter$.next(themeConfig.iconFilter);
      this.iconName$.next(themeConfig.iconName);
    }
  }
}
